import { useEffect, useRef } from 'react';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { getUserManager } from '../auth/oidc';
import { useAuth } from '../context/auth-context';

/**
 * OIDC redirect target. Completes the PKCE code exchange in the browser, then
 * exchanges the resulting ID token for a Unity Catalog token (UC_TOKEN cookie).
 */
export default function AuthCallback() {
  const { loginWithToken } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    getUserManager()
      .signinRedirectCallback()
      .then(async (user) => {
        const state = user.state as { returnTo?: string } | undefined;
        if (!user.id_token) {
          throw new Error('Identity provider returned no ID token');
        }
        await loginWithToken(user.id_token);
        navigate(state?.returnTo || '/', { replace: true });
      })
      .catch((error) => {
        console.error('Keycloak login failed:', error);
        navigate('/', { replace: true });
      });
  }, [loginWithToken, navigate]);

  return (
    <Typography.Text style={{ padding: 24, display: 'block' }}>
      Signing in...
    </Typography.Text>
  );
}
